<!--
 * @Author: cgh
 * @Date: 2022-09-23
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 17:43:14
 * @Description: 项目转移
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-60 o-dialog--xl-50"
    title="项目转移"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="150px"
        label-suffix="："
      >
        <el-row class="c-form__row">
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="项目名称"
              prop="xmmc"
            >
              <span class="c-form__read">
                {{ fd.xmmc }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="企业名称"
              prop="wtdw"
            >
              <span
                class="c-form__read"
              >
                {{ fd.wtdw || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="项目地址"
              prop="xmdz"
            >
              <span
                class="c-form__read"
              >
                {{ fd.xmdz || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="重点单位"
              prop="zddwStr"
            >
              <span
                class="c-form__read"
              >
                {{ fd.zddwStr || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="合同有效期"
              prop="htyxq"
            >
              <span
                class="c-form__read"
              >
                {{ fd.htyxqQStr || '-' }} 至 {{ fd.htyxqZStr || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="建筑数"
              prop="jzs"
            >
              <span
                class="c-form__read"
              >
                {{ fd.jzs || '0' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="所属账号"
              prop="sszhMc"
            >
              <el-select
                v-model="fd.sszhDm"
                clearable
                value-key="value"
                placeholder="请选择所属账号"
              >
                <el-option
                  v-for="item in userList"
                  :key="item.capacityCode"
                  :label="item.capacityName"
                  :value="item.capacityCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="创建时间"
              prop="cjsjStr"
            >
              <span
                class="c-form__read"
              >
                {{ fd.cjsjStr || '-' }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleTranslateXm()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { wbxmService } from './wbxm.service.js';

// 继承于新增用户
export default {
  name: 'WbTranslateDialog',
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示
      xmId: '', // 项目ID
      userList: [], // 可转移用户列表
      loading: false, // 页面是否加载
      fd: {
        xmId: '',
        xmmc: '',
        wtdw: '',
        xmdz: '',
        zddwStr: '',
        htyxqQStr: '',
        htyxqZStr: '',
        jzs: '',
        sszhMc: '',
        sszhDm: '',
        cjsjStr: ''
      },

      /* 表单校验规则 Start */
      fdRules: {
        sszhDm: [
          this.$validUtils.required('所属账号')
        ]
      }
      /* 表单校验规则 End */
    };
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },

    /**
     * @description: 项目转移
     * @return {*}
     * @param {*} _xmId
     * @param {*} _capacityCode
     */
    handleTranslateXm () {
      const _this = this;
      _this.loading = true;
      var _params = {
        xmId: _this.fd.xmId,
        capacityCode: _this.fd.sszhDm
      };
      wbxmService.translate(_params)
        .then(rsp => {
          _this.$alert('项目转移成功', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('维保项目转移失败！', err);
        })
        .finally(() => {
          _this.loading = false;
        });
    },

    /**
     * @description: 获取项目可转移用户列表
     * @return {*}
     */
    handleTranslateUsers () {
      const _this = this;
      wbxmService.getTranslateUsers(_this.fd.xmId)
        .then(rsp => {
          _this.userList = rsp.data;
        })
        .catch(err => {
          console.error('获取项目可转移用户列表失败！', err);
        })
        .finally(() => {
          _this.loading = false;
        });
    },

    /**
     * @description: 初始化
     * @return {*}
     */
    init () {
      this.handleTranslateUsers();
    }
  },
  created () {
    this.fd = this.dlParams;
    this.init();
  }
};
</script>
